import { useEffect, useState } from 'react';
import type { TenantConfig } from '@/types';

export function useTenantConfig() {
  const [config, setConfig] = useState<TenantConfig | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const url = new URL(window.location.href);
    // Permite forçar ?tenant=slug no dev
    const qs = url.searchParams.get('tenant');
    const endpoint = qs ? `/api/config?tenant=${encodeURIComponent(qs)}` : '/api/config';

    fetch(endpoint)
      .then(async (r) => {
        if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
        return r.json();
      })
      .then((json) => setConfig(json as TenantConfig))
      .catch((e: any) => setError(e.message || 'Erro ao carregar config'))
      .finally(() => setLoading(false));
  }, []);

  return { config, error, loading };
}